// extracted by mini-css-extract-plugin
export default {"main":"PartnersSection_main__P7iRV","headerText":"PartnersSection_headerText__HYxxa","eachSlide":"PartnersSection_eachSlide__g+kVP"};